module.exports = __webpack_public_path__ + "img/hole-3.6bfa629d.png";